import React from "react";
import get from "lodash/get";
import dayjs from "dayjs";
import { RoundIcon, RoundIconWrapper, Counter } from "./styled";

const MINS = 60;

const Notification = ({ row, intl }) => {
  const newChat = get(row, "notifications.newChat", false);
  const unreadTextMessage = get(row, "unreadTextMessageCount", 0);

  if (newChat) {
    return (
      <RoundIcon
        color="info"
        className="fad fa-comment"
        title={intl.formatMessage({ id: "Tickets.notifications.chat" })}
      />
    );
  }

  if (unreadTextMessage) {
    return (
      <RoundIconWrapper
        title={intl.formatMessage({ id: "Tickets.notifications.textMessage" })}
      >
        <RoundIcon color="info" className="fad fa-sms" />
        <Counter>{unreadTextMessage}</Counter>
      </RoundIconWrapper>
    );
  }

  let mins = dayjs().diff(dayjs(row.updated), "m");

  if (mins <= MINS) {
    return (
      <RoundIcon
        opacity={(MINS - mins) / MINS}
        color="danger"
        className="fad fa-heart-rate"
        title={intl.formatMessage({ id: "Tickets.notifications.updated" })}
      />
    );
  }

  return null;
};

export default Notification;
